export default Object.freeze({
    SIDE_OF_BENEFIT_BOTH: 'both',
    SIDE_OF_BENEFIT_REFERRER: 'referrer',
});



// WEBPACK FOOTER //
// ./src/Assets/components/ReferralSchemes/consts/sides_of_benefit.js